function Header() {
  return (
    <div className="text-center">
      <h1 className="display-2">Fitness and Activeness Tracker App</h1>
    </div>
  );
}

export default Header